import { createContext, useCallback, useReducer } from "react";
import FaresReducer from "./FareReducer";
import { getFares } from "./apiCalls"; // change this to your actual path

const INITIAL_STATE = {
    fares: [],
    isFetching: false,
    error: false,
    hasFetched: false,
};

export const FaresContext = createContext(INITIAL_STATE);

export const FaresContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        FaresReducer,
        INITIAL_STATE
    );

    const fetchFares = useCallback(
        async (toast, forceRefresh = false) => {
            // Already fetched → don't call API again
            if (state.hasFetched && !forceRefresh) {
                return;
            }

            await getFares(dispatch, toast);
        },
        [state.hasFetched]
    );

    return (
        <FaresContext.Provider
            value={{
                fares: state.fares,
                isFetching: state.isFetching,
                error: state.error,
                hasFetched: state.hasFetched,
                dispatch,
                fetchFares,
            }}
        >
            {children}
        </FaresContext.Provider>
    );
};